import React, { Suspense, lazy } from 'react';
import Loading from '../LoadingComponent';

const Batch = lazy(() =>
  import(/* webpackChunkName: "Batch" */ '../../components/rewards/Batch')
);

export default function AsyncBatch({...props}) {
  return (
    <Suspense fallback={<Loading />}>
      <Batch {...props} />
    </Suspense>
  );
}
